import styled from 'styled-components';

export const ContainerWrap = styled.div`
  order: 1;
  border: 1px solid ${({ theme }) => theme.colors.grayDark};
  border-radius: 6px;
  margin-bottom: 5px;
`;
